import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";

const getComplaintForUser = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/ComplaintForUser",
    params
  );
};

const getComplaintForNoti = (departmentId, userActive) => {

  const params = {
    departmentId,
    userActive,
  }

  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/ComplaintForNoti",
    params
  );
}

const postComplaintRecieveDate = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/ComplaintRecieveDate",
    params
  )
}

export { getComplaintForUser, getComplaintForNoti, postComplaintRecieveDate };
